import {IStateTimeTable} from './reducer';
import {
  createAction,
  createActionFetch,
  createBasicActions,
} from '../../../common/util/redux';
import {IBigContent} from '../../../commonSub/type';
import {
  IContentListByDay,
  IContentListByDays,
  ITimeTableContent,
  ITimeTableDay,
  ITimeTableGenreItem,
  ITimeTablePage,
  ITimeTableSortKey,
} from '../type';

export enum ActionType {
  SetValue = 'timeTable.SetValue',
  SetPropertyValues = 'timeTable.SetPropertyValues',
  FetchWeekday = 'timeTable.FetchWeekday',
  FetchNewContents = 'timeTable.FetchNewContents',
  FetchCompletedContents = 'timeTable.FetchCompletedContents',
  FetchCompletedGenres = 'timeTable.FetchCompletedGenres',
  FetchNewContentLike = 'timeTable.FetchNewContentLike',
  SetNewContentLike = 'timeTable.SetNewContentLike',
  SetNewContents = 'timeTable.SetNewContents',
  SetCompletedContents = 'timeTable.SetCompletedContents',
  SetCompletedGenres = 'timeTable.SetCompletedGenres',
  SetCompletedGenreKey = 'timeTable.SetCompletedGenreKey',
  SetDayContent = 'timeTable.SetDayContent',
  SetWeekdaysContents = 'timeTable.SetWeekdaysContents',
  InitializeTimeTable = 'timeTable.InitializeTimeTable',
}

export const actions = {
  ...createBasicActions<IStateTimeTable>({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
  }),
  fetchWeekday: (payload: {key?: ITimeTableSortKey; day: ITimeTableDay}) =>
    createActionFetch(ActionType.FetchWeekday, {
      payload,
      fetchKey: payload.day,
    }),
  fetchNewContents: (page: ITimeTablePage) =>
    createActionFetch(ActionType.FetchNewContents, {
      payload: {page},
      fetchKey: page,
    }),
  fetchCompletedContents: (page: ITimeTablePage, genre?: string) =>
    createActionFetch(ActionType.FetchCompletedContents, {
      payload: {page, genre},
      fetchKey: page,
    }),
  fetchCompletedGenres: () =>
    createActionFetch(ActionType.FetchCompletedGenres),
  fetchNewContentLike: (payload: {
    contentId: number;
    index: number;
    isLike: boolean;
  }) => createActionFetch(ActionType.FetchNewContentLike, {payload}),
  setNewContentLike: (payload: {index: number; isLike: boolean}) =>
    createAction(ActionType.SetNewContentLike, payload),
  setNewContents: (page: ITimeTablePage, contents: IBigContent[]) =>
    createAction(ActionType.SetNewContents, {page, contents}),
  setCompletedGenres: (data: ITimeTableGenreItem[]) =>
    createAction(ActionType.SetCompletedGenres, {data}),
  setCompletedGenreKey: (page: ITimeTablePage, selectedKey: string) =>
    createAction(ActionType.SetCompletedGenreKey, {page, selectedKey}),
  setCompletedContents: ({
    page,
    bigContent,
    contents,
  }: {
    page: ITimeTablePage;
    bigContent?: IBigContent;
    contents: ITimeTableContent[];
  }) =>
    createAction(ActionType.SetCompletedContents, {
      bigContent,
      contents,
      page,
    }),
  setDayContent: (payload: {
    day: ITimeTableDay;
    item: IContentListByDay;
    sortKey?: ITimeTableSortKey;
  }) => createAction(ActionType.SetDayContent, payload),
  setWeekdaysContents: (
    page: ITimeTablePage,
    contentListByDays: IContentListByDays
  ) => createAction(ActionType.SetWeekdaysContents, {page, contentListByDays}),
  initializeTimeTable: (page: ITimeTablePage) =>
    createAction(ActionType.InitializeTimeTable, {page}),
};
